import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Statistics } from 'src/app/models/statistics.model';
import { BaseApiService } from '../base/base-api.service';

/**
 * Statistics Service - Handles statistics queries and counts
 */
@Injectable({ providedIn: 'root' })
export class StatisticsService extends BaseApiService {
    private readonly searchPath = '/statistics/v1/query';
    private readonly countPath = '/statistics/v1/count';

    constructor(http: HttpClient) {
        super(http);
    }

    /*-------------------------
    == STATISTICS CALLS ==
    -------------------------*/

    statisticsSearch(index: string, requestBody: string): Observable<Statistics> {
        return this.getAll<Statistics>(this.searchPath, {
            customParams: { index, requestBody }
        });
    }

    statisticsCount(index: string, requestBody: string): Observable<Statistics> {
        return this.getAll<Statistics>(this.countPath, {
            customParams: { index, requestBody }
        });
    }

    // NOTE: This method duplicates functionality in ValuationService
    // Consider removing this and using ValuationService.getValuations() instead
    getValuations(limit: number, page: number, orderBy?: string, filter?: string, fields?: string, defaultFilter?: string): Observable<any> {
        return this.getAll<any>('/request/v1/valuation/', { limit, page, orderBy, filter, customParams: fields ? { fields } : (defaultFilter ? { defaultFilter } : undefined) });
    }
}
